import { ReactNode, useCallback } from "react";
import { useQuery } from "../database-provider";
import { ArmiesRulesetsContext } from "./context";

export function ArmiesRulesetsFetcher(props: { children: ReactNode }) {
  const result = useQuery(useCallback((db) => db.getArmiesRulesets(), []));
  return (
    <ArmiesRulesetsContext.Provider value={result}>{props.children}</ArmiesRulesetsContext.Provider>
  );
}
